import { Button, Typography } from '../../designComponents';
import { LastSection } from './style';

type Props = {};

const Connect = (_props: Props) => {
  return (
    <LastSection>
      <div className="content">
        <Typography className="content-title">
          Connect With Us Today: Your Queries Await Answers!
        </Typography>
        <Typography className="content-desc">
          Have questions or need assistance? Don't hesitate to reach out to us.
          Our team is here to provide prompt and helpful responses to all your
          inquiries.
        </Typography>
        <Button style={{ borderRadius: '28px' }}>Contact Us Now</Button>
      </div>
    </LastSection>
  );
};

export default Connect;
